'use strict';

var EditNat = require('actionGroups/advancedNat/Nat');

module.exports = {
  Model: EditNat,
};
